import { EN_NODE_TYPE, NodeTypeDefaultValueMap } from '@do-lib/global-interface';

/** 单元节点投图设置：线型可见性默认不跟随全局（跟随全局开关关闭） */
export function applyUnitViewCurvesVisibilityDefault(
  nodeTypeDefaultValueMap: typeof NodeTypeDefaultValueMap,
): void {
  const unitSettings = nodeTypeDefaultValueMap[EN_NODE_TYPE.单元];
  if (!unitSettings) {
    return;
  }
  for (const projectTypeKey of Object.keys(unitSettings)) {
    const config = unitSettings[projectTypeKey as keyof typeof unitSettings];
    if (config?.viewCurvesVisibilitySetting) {
      config.viewCurvesVisibilitySetting.bCustomSetting = true;
    }
  }
}
